module.exports = __webpack_public_path__ + "img/IT0000100778167.c57933b0.png";